var $5d376b7fce1a45b2$exports = {};
$5d376b7fce1a45b2$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \u2013 ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " valittu");
  },
  "finishRangeSelectionPrompt": "Lopeta p\xE4iv\xE4m\xE4\xE4r\xE4alueen valinta napsauttamalla t\xE4t\xE4.",
  "maximumDate": "Viimeinen varattavissa oleva p\xE4iv\xE4m\xE4\xE4r\xE4",
  "minimumDate": "Ensimm\xE4inen varattavissa oleva p\xE4iv\xE4m\xE4\xE4r\xE4",
  "next": "Seuraava",
  "previous": "Edellinen",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valittu p\xE4iv\xE4m\xE4\xE4r\xE4: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valittu aikav\xE4li: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Aloita p\xE4iv\xE4m\xE4\xE4r\xE4alueen valinta napsauttamalla t\xE4t\xE4.",
  "todayDate": function todayDate(args) {
    return "T\xE4n\xE4\xE4n, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "T\xE4n\xE4\xE4n, ".concat(args.date, " valittu");
  }
};
export { $5d376b7fce1a45b2$exports as default };